export default __webpack_public_path__ + "img/img_meher-da66bcb09ade615ac9d6db515ede3ddc.jpg";